<section class="wizard-steps-bar">
  <ul>
    <ng-template ngFor let-step [ngForOf]="steps" let-i="index">
      <li [class.selected]="step.selected" [class.completed]="step.valid" class="separator"
        *ngIf="i > 0 && step.enabled"></li>
      <li [class.selected]="step.selected" [class.completed]="step.valid" *ngIf="step.enabled && !step.error"
        style="position: relative; z-index: 1" (click)="stepClicked(step)">
        <div class="step-icon-parts">
          <div style="position: absolute">
            <i inlineSVG="/assets/icons/wizards/completed-step.svg" class="completed"></i>
          </div>
          <i inlineSVG="/assets/icons/wizards/{{ step.svg }}.svg" class="step-icon"></i>
        </div>
        <span class="name">{{ step.name }}</span>
        <svg height="7" width="12" class="sel-indicator-arrow">
          <g>
            <polygon points="6,0 0,7 12,7" />
          </g>
        </svg>
      </li>
      <li [class.selected]="step.selected" [class.completed]="step.error" [class.errored]="step.error"
        *ngIf="step.error" (click)="stepClicked(step)">
        <div class="step-icon-parts">
          <i inlineSVG="/assets/icons/icon_error-step.svg" class="error"></i>
          <i inlineSVG="/assets/icons/wizards/{{ step.svg }}.svg" class="step-icon"></i>
        </div>
        <span class="name">{{ step.name }}</span>
        <svg height="7" width="12" class="sel-indicator-arrow">
          <g>
            <polygon points="6,0 0,7 12,7" />
          </g>
        </svg>
      </li>
    </ng-template>
    <div *ngIf="quoteRequestId" class="class-note">
      <li inlineSVG="/assets/icons/wizards/icon_notes.svg" (click)="openDialog()"></li>
    </div>
  </ul>
</section>
